
import * as React from 'react';
import { resolve } from 'inversify-react';
import { HttpService } from 'src/core/services/http.service';
import { CommunicationService } from 'src/core/services/communication.service';

interface IState{

	connected: boolean;
	remaining: number;
}

export default class PingComponent extends React.Component<any, IState>{


	constructor(props) {
		super(props);
		
		this.state = {
			connected: false,
			remaining: -1
		}
	}

	@resolve
	httpService: HttpService;

	@resolve
	realTimeService: CommunicationService;

	interval: any;

	public componentDidMount() {
		this.realTimeService.EventEmitter.on("connectionStatus", this.updateStatus);


		// this.realTimeService.onDisconnect = () => this.setState({ error: true });
		// this.realTimeService.onReconnect = () => this.setState({ error: false });
	}
	

	updateStatus = (data: { connected: boolean, time: number, err: any }) => {
		this.setState({ connected: data.connected });

		if (!data.connected) {
			this.setState({ remaining: data.time }, this.setWatcher);
		}
		else
			this.setState({ remaining: 0 }, this.removeWatcher)
	}

	setWatcher = () => {
		if(!this.interval)
			this.interval = setInterval(() => {
				this.setState({ remaining: this.state.remaining > 0? this.state.remaining - 1: 0 })
			}, 1000);
	}

	removeWatcher = () => {
		clearInterval(this.interval);
	}

	public componentWillUnmount() {
		this.realTimeService.EventEmitter.removeListener("connectionStatus", this.updateStatus);
		if (this.interval)
			clearInterval(this.interval);
	}

	render() {

		if (this.state.connected)
			return null;

		return <div style={{ position: 'fixed', width: '100%', color: 'white', backgroundColor: 'red', zIndex: 99999, top: '0px', left: '0px', opacity: 0.8, textAlign: 'center' }}>The real time communication service is offline.{this.state.remaining <=0 && <label>Reconnecting...</label>} {this.state.remaining > 0 && <label>Trying to reconnect in {this.state.remaining} s </label>}</div>

	}

}



// WEBPACK FOOTER //
// ./src/core/ui/ping-component.tsx